var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCommentWidgetIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 18,
  viewBox: "0 0 17 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.6 14H14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v13.2L4.6 14zm.3 1L0 18V3c0-1.7 1.3-3 3-3h11c1.7 0 3 1.3 3 3v9c0 1.7-1.3 3-3 3H4.9z",
  fill: "#none"
})));
export default SvgCommentWidgetIcon;